import i18next from 'i18next';
import segment from '../../analytics/segment';
import { premiumFeatures } from '../../common/constants/premium-features';

const {
  constants: { triggerIds },
} = segment;

const getCaptionsForPaywall = ({ isB2C, triggerId, premiumFeature, isFreeTrialAvailable }) => {
  if (isFreeTrialAvailable) {
    const captions = {
      backButtonLabel: i18next.t('Back'),
      plan: {
        buttonLabel: i18next.t('Start Free Trial'),
      },
    };

    if (premiumFeature === premiumFeatures.CUSTOM_DOMAIN) {
      return {
        ...captions,
        title: `${i18next.t('Try the best of Yola.')}<br/>${i18next.t(
          'First two weeks are on us'
        )}`,
        description: {
          first: i18next.t(
            'Start the 14-day free trial and only pay for your domain today. Cancel anytime'
          ),
        },
      };
    }

    return {
      ...captions,
      title: i18next.t('Start Your Free Website Trial'),
      description: {
        first: i18next.t(
          "Choose the website plan that's right for your business. 14-day free trial. Cancel anytime."
        ),
      },
    };
  }

  const defaultB2CDescription = {
    ...(isB2C && {
      first: i18next.t(
        'Choose the website plan that`s right for your business. Get visitors, sell products, and grow your business online'
      ),
    }),
  };

  const ecommerceDependentDescription = {
    first: i18next.t(
      'To unlock your Online store’s paid subscription, you must first upgrade your hosting plan'
    ),
  };

  const defaultDescription = isB2C ? defaultB2CDescription : {};

  return {
    backButtonLabel: i18next.t('Back'),
    description:
      triggerId === triggerIds.ECOMMERCE_PAYWALL
        ? ecommerceDependentDescription
        : defaultDescription,
  };
};

export default getCaptionsForPaywall;
